import { useQuery } from '@tanstack/react-query';
import { IGetAllPlantypes } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllPlantypes = async (
) => {
  const res = await apiManager.get<IGetAllPlantypes>(
    "subscription-plan-type/get-all"
  );
  return res;
};

export const useGetAllPlanTypes = () =>
  useQuery<IGetAllPlantypes>({
    queryKey: ["get_all_plan_types"],
    queryFn: async (): Promise<IGetAllPlantypes> => {
      const res = await apiClient.get(ENDPOINTS.SUBSCRIPTION_PLANS.GET_PLAN_TYPES);
      return res.data;
    },
  });